import { HTTP_INTERCEPTORS } from '@angular/common/http';
import { CUSTOM_ELEMENTS_SCHEMA, NgModule } from '@angular/core';
import { MatCardModule } from '@angular/material/card';
import { MatNativeDateModule } from '@angular/material/core';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { MatStepperModule } from '@angular/material/stepper';
import { MatToolbarModule } from '@angular/material/toolbar';
import { BrowserModule } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { StepperModule } from '@progress/kendo-angular-layout';
import { BaseHttpService } from '../app-core/services/base-http.service';
import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { BookingRedirectComponent } from './booking-redirect/booking-redirect.component';
import { FaqSectionComponent } from './faq-section/faq-section.component';
import { FooterComponent } from './footer/footer.component';
import { HeaderComponent } from './header/header.component';
import { LandingPageComponent } from './landing-page/landing-page.component';
import { AppCommonModule } from './shared/app-common.module';
import { LoaderIndicatorComponent } from "./shared/loader-indicator/loader-indicator.component";
import { TrackMyAppointmentComponent } from './track-my-appointment/track-my-appointment.component';
import { TrackingHistoryComponent } from './tracking-history/tracking-history.component';
import { TrackingRedirectComponent } from './tracking-redirect/tracking-redirect.component';
import { UpdateDialogComponent } from './update-dialog/update-dialog.component';
import { UpdateOrderDetailsComponent } from './update-order-details/update-order-details.component';

@NgModule({
    declarations: [
        AppComponent,
        LandingPageComponent,
        FooterComponent,
        TrackingHistoryComponent,
        FaqSectionComponent,
        UpdateDialogComponent,
        UpdateOrderDetailsComponent,
        HeaderComponent,
        TrackMyAppointmentComponent,
        TrackingRedirectComponent,
        BookingRedirectComponent
    ],
    imports: [
        BrowserModule,
        BrowserAnimationsModule,
        AppRoutingModule,
        AppCommonModule,
        MatCardModule,
        MatToolbarModule,
        StepperModule,
        MatStepperModule,
        MatDatepickerModule,
        MatFormFieldModule,
        MatInputModule,
        MatNativeDateModule,
        LoaderIndicatorComponent
    ],
    providers: [
        { provide: HTTP_INTERCEPTORS, useClass: BaseHttpService, multi: true }
    ],
    bootstrap: [AppComponent],
    schemas: [CUSTOM_ELEMENTS_SCHEMA]
})
export class AppModule { }
